/**
 * Shared Form.io render options — UserFormView, FormioTabRenderer, GuestEdit, ParticipantEdit.
 * Contract:
 * - validateOn: "submit" + highlightErrors: false → no eager red marks on load/tab switch
 * - Failed Save → caller runs forceFormioShowValidationErrors + show-errors CSS
 */
export const USER_PORTAL_FORMIO_OPTIONS = {
  noAlerts: false,
  validateOn: "submit",
  highlightErrors: false,
  alwaysDirty: false,
  lazyLoad: false,
  disableBrowserSpellcheck: false,
  errorOnEmpty: false,
  disableErrorMessages: false,
  renderMode: "form",
  sanitizeConfig: {
    addTags: ["span"],
    addAttrs: { span: ["style", "class", "aria-hidden"] },
  },
};
